

























import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import * as types from "@/store/constants/setting_types";
import { payByAny } from "@/services/payment/payment_check/payment_check_logic";

@Component({
  components: {}
})
export default class LuckyCoin extends Vue {
  @Getter(types.GETTER_TAB_COIN_STORE_SETTINGS)
  private tabCoinStore: any;
  get luckyCoinOffer() {
    return (
      this.tabCoinStore &&
      this.tabCoinStore.lucky_coin_offers &&
      this.tabCoinStore.lucky_coin_offers[0]
    );
  }
  get lucky_effect() {
    return this.luckyCoinOffer && this.luckyCoinOffer.lucky_effect;
  }
  get min() {
    return this.lucky_effect && this.lucky_effect.min
      ? this.lucky_effect.min
      : 250;
  }
  get max() {
    return this.lucky_effect && this.lucky_effect.max
      ? this.lucky_effect.max
      : 1000000;
  }
  private goBuy() {
    payByAny({ offer: this.luckyCoinOffer });
  }
}
